import type { ReactNode } from "react";

import { StatTile } from "./StatTile";
import { t } from "../../lib/i18n";

import "./ui.css";

export interface SummaryMetric {
  labelKey: string;
  value: ReactNode;
  /** Optional translation key for a one-line caption under the value. */
  captionKey?: string;
}

interface ReportSummaryCardsProps {
  /** Array of `{ labelKey, value, captionKey }` rendered as a stat grid. */
  metrics: SummaryMetric[];
}

export function ReportSummaryCards({ metrics }: ReportSummaryCardsProps) {
  return (
    <div className="stat-grid">
      {metrics.map((m) => (
        <StatTile
          key={m.labelKey}
          label={t(m.labelKey)}
          value={m.value}
          sub={m.captionKey ? t(m.captionKey) : undefined}
        />
      ))}
    </div>
  );
}
